<script>
  import Heading from "./heading.svelte";
  export let id;
  export let title;
</script>

<style>
  :global(.page-container) {
    margin: auto;
    margin-bottom: 3em;
    padding-top: 3em;
    max-width: 52em !important;
    letter-spacing: 0.01em !important;
    line-height: 1.8em;
    border-top: solid 1px #d6d6d6;
  }
</style>

<div class="page-container" {id}>
  <Heading {title} />
  <slot />
</div>
